/**
 * PriceGuidePDF
 * 
 * @Author: Focci
 * @Date: 2024-02-19 14:07:45
 * @Last Modified by: Focci
 * @Last Modified time: 2024-02-19 14:07:45
 */

'use client'

import PropTypes from 'prop-types'
import SVGDocuments from '@img/documents.svg'
import useTracking from '@hook/useTracking'
import { houseToGta, isAU } from '@lib/utils'
import { useCallback } from 'react'
import Link from 'next/link'
import { useTranslations } from 'next-intl'

export default function PriceGuidePDF({ house }) {
  const th = useTranslations('house')
  const { priceGuideUrl, priceGuideDesc } = house || {}
  const { pushTrack } = useTracking()

  const handleClick = useCallback(() => {
    isAU && pushTrack('homely_statement_of_information', houseToGta(house))
  }, [house, pushTrack])

  if(!((priceGuideUrl || priceGuideDesc) && isAU)) {
    return null
  }

  return (
    <div className="py-2 flex items-center gap-2">
      {priceGuideDesc && (
        <b className="bg-cf0 text-meta text-f.6 px-2 py-1 rounded-md">
          {`${th('guidancePrice')} ${priceGuideDesc}`}
        </b>
      )}
      <Link
        href={priceGuideUrl}
        target="_blank"
        onClick={handleClick}
        className="inline-flex items-center gap-x-2 hover:underline text-primary"
      >
        <span>{th('priceGuidance')}</span>
        <SVGDocuments />
      </Link>
    </div>
  )
}

PriceGuidePDF.propTypes = {
  house: PropTypes.object,
}
